"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _button = _interopRequireDefault(require("antd/lib/button"));

var _locales = require("@meepshop/locales");

require("./styles/index.less");

var styles = {
  "root": "store-refactor__CloseView-index__root"
};

var _default = function _default(_ref) {
  var closed = _ref.closed;

  var _useTranslation = (0, _locales.useTranslation)('common'),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.root
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: require("@meepshop/images/lib/getImage")["default"]({
      stage: "https://img.meepstage.com/rPWkArNhWb68F5cmSOHj5TcySx_9kgh5sBR7arsWWE8/Z3M6Ly9pbWcubWVlcGNsb3VkLmNvbS9hc3NldHMvc3RvcmVDbG9zZS5zdmc.svg",
      production: "https://img.meepshop.com/w21EqN8uYN96jAnXTU4nKeZDDegrSWFzzCU56BmtqSs/Z3M6Ly9pbWcubWVlcGNsb3VkLmNvbS9hc3NldHMvc3RvcmVDbG9zZS5zdmc.svg"
    }),
    alt: "store-close"
  }), /*#__PURE__*/_react["default"].createElement("div", null, t("".concat(closed, ".title"))), /*#__PURE__*/_react["default"].createElement("div", null, t("".concat(closed, ".description"))), /*#__PURE__*/_react["default"].createElement("div", null, closed === 'RESTED' ? 'Sorry, we are temporarily closed and will be back soon.' : 'Sorry, we are closed and will be back soon.'), /*#__PURE__*/_react["default"].createElement(_button["default"], {
    type: "primary",
    shape: "round",
    href: "https://meepshop.cc/61Xeh",
    target: "_blank"
  }, t('want-to-open-store')));
};

exports["default"] = _default;